import React from "react"
import propTypes from "prop-types"
import Loader from "react-loader-spinner"
import { connect } from "react-redux"
import { CSSTransition, SwitchTransition } from "react-transition-group"
import { validateForm } from "../../../../../../services/validation"
import { saveAboutMe } from "../../../../../../services/plans"
import configs from "../../../../../../configs"

import RequestSupport from "../../../../components/RequestSupport"
import Form, { Group, TextArea } from "../../../../../../components/Form"
import Button from "../../../../../../components/Button"
import Tooltip from "../../../../../../components/Tooltip"

class AboutMe extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      form: {
        step1: {
          name: "step1",
          key: "support_me",
          type: "textarea",
          value: "",
          required: false
        },
        step2: {
          name: "step2",
          key: "daily_life",
          type: "textarea",
          value: "",
          required: false
        },
        step3: {
          name: "step3",
          key: "about_me",
          type: "textarea",
          value: "",
          required: false
        },
        step4: {
          name: "step4",
          key: "health_and_wellbeing",
          type: "textarea",
          value: "",
          required: false
        },
        step5: {
          name: "step5",
          key: "safety_concerns",
          type: "textarea",
          value: "",
          required: false
        },
        step6: {
          name: "step6",
          key: "communication_and_decision_making",
          type: "textarea",
          value: "",
          required: false
        },
        step7: {
          name: "step7",
          key: "studying",
          type: "textarea",
          value: "",
          required: false
        },
        step8: {
          name: "step8",
          key: "transportation",
          type: "textarea",
          value: "",
          required: false
        },
        step9: {
          name: "step9",
          key: "extra_info",
          type: "textarea",
          value: "",
          required: false
        }
      },
      activeStep: 1,
      stepsState: true,
      isSubmitted: false,
      requestSupportIsHidden: true
    }
  }

  componentDidMount() {
    const {
      id,
      store: { plan }
    } = this.props

    if (plan.answers.aboutMe) {
      this.setForm()
    }

    if (!!id && id <= 9) {
      this.setState({
        activeStep: +id
      })
    }
  }

  componentDidUpdate(prevProps) {
    const {
      store: { plan }
    } = this.props

    if (plan.answers.aboutMe) {
      if (
        JSON.stringify(prevProps.store.plan.answers.aboutMe) !==
        JSON.stringify(plan.answers.aboutMe)
      ) {
        this.setForm()
      }
    }
  }

  requestSupportToggle = () => {
    const { requestSupportIsHidden } = this.state

    this.setState({ requestSupportIsHidden: !requestSupportIsHidden })
  }

  setForm = () => {
    const { form } = this.state
    const {
      store: { plan }
    } = this.props

    this.setState({
      form: {
        step1: {
          ...form.step1,
          value: plan.answers.aboutMe.support_me || ""
        },
        step2: {
          ...form.step2,
          value: plan.answers.aboutMe.daily_life || ""
        },
        step3: {
          ...form.step3,
          value: plan.answers.aboutMe.about_me || ""
        },
        step4: {
          ...form.step4,
          value: plan.answers.aboutMe.health_and_wellbeing || ""
        },
        step5: {
          ...form.step5,
          value: plan.answers.aboutMe.safety_concerns || ""
        },
        step6: {
          ...form.step6,
          value: plan.answers.aboutMe.communication_and_decision_making || ""
        },
        step7: {
          ...form.step7,
          value: plan.answers.aboutMe.studying || ""
        },
        step8: {
          ...form.step8,
          value: plan.answers.aboutMe.transportation || ""
        },
        step9: {
          ...form.step9,
          value: plan.answers.aboutMe.extra_info || ""
        }
      }
    })
  }

  scrollToInvalidElement = fields => {
    const offSet =
      this.form.elements[
        fields.name
      ].parentNode.parentNode.getBoundingClientRect().top + window.pageYOffset
    const supportsNativeSmoothScroll =
      "scrollBehavior" in document.documentElement.style

    if (supportsNativeSmoothScroll) {
      window.scrollTo({
        top: offSet,
        behavior: "smooth"
      })
    } else {
      window.scrollTo(0, offSet)
    }
  }

  handleNext = () => {
    const { activeStep, form, stepsState } = this.state
    const {
      onNext,
      scrollToNav,
      onSaveAboutMe,
      store: { plan, user }
    } = this.props

    if (user.list_role.includes(configs.roles.Guardian)) {
      if (activeStep >= 9) {
        onNext()
      } else {
        scrollToNav()

        this.setState({
          activeStep: activeStep + 1,
          stepsState: !stepsState,
          requestSupportIsHidden: true
        })
      }

      return
    }

    const name = `step${activeStep}`
    const field = form[name]
    const result = validateForm({ [name]: field })[name]

    if (result) {
      this.scrollToInvalidElement(result)

      this.setState({
        isSubmitted: true,
        form: {
          ...form,
          [name]: result
        }
      })
      return
    }

    const item = {}
    item[field.key] = field.value

    onSaveAboutMe(user.token, plan.id, item).then(() => {
      if (activeStep >= 9) {
        onNext()
      } else {
        scrollToNav()

        this.setState({
          activeStep: activeStep + 1,
          stepsState: !stepsState,
          requestSupportIsHidden: true
        })
      }
    })
  }

  handleBack = () => {
    const { onBack } = this.props
    const { activeStep, stepsState } = this.state

    if (activeStep === 1) {
      onBack()
    } else {
      this.setState({ activeStep: activeStep - 1, stepsState: !stepsState })
    }
  }

  onChange = (name, field, value) => {
    const { form } = this.state

    this.setState({
      form: {
        ...form,
        [name]: {
          ...form[name],
          message: "",
          [field]: value
        }
      }
    })
  }

  render() {
    const {
      form,
      activeStep,
      isSubmitted,
      stepsState,
      requestSupportIsHidden
    } = this.state
    const {
      store: { plan }
    } = this.props

    return (
      <>
        <div className="pre-plan_header">
          <div className="pre-plan_title">About Me</div>
          <div className="pre-plan_description">
            Let us know about your current living situation so we can better
            understand what you need.
          </div>
        </div>

        {plan.loading ? (
          <Loader
            type="TailSpin"
            color="#0c4632"
            height={80}
            width={80}
            className="loader"
          />
        ) : (
          <div className="row">
            <div className="col-xl-8 offset-xl-2">
              <Form
                formRef={el => {
                  this.form = el
                }}
              >
                <SwitchTransition>
                  <CSSTransition
                    timeout={300}
                    key={stepsState}
                    classNames="fade"
                  >
                    {(() => {
                      switch (activeStep) {
                        case 1:
                          return (
                            <div className="pre-plan_step">
                              <div className="pre-plan_step_title">
                                Question {activeStep}/9
                                <Tooltip>
                                  Let us know where home is for you, who
                                  supports you and what they do to help you.
                                </Tooltip>
                              </div>
                              <div className="pre-plan_step_description">
                                Where do you live and who are the people that
                                support you?
                              </div>

                              <Group className="form_group--float-label">
                                <TextArea
                                  onChange={this.onChange}
                                  isSubmitted={isSubmitted}
                                  field={form.step1}
                                />
                              </Group>
                            </div>
                          )
                        case 2:
                          return (
                            <div className="pre-plan_step">
                              <div className="pre-plan_step_title">
                                Question {activeStep}/9
                                <Tooltip>
                                  What does an average day look like for you?
                                </Tooltip>
                              </div>
                              <div className="pre-plan_step_description">
                                Tell us about your daily life.
                              </div>

                              <Group className="form_group--float-label">
                                <TextArea
                                  onChange={this.onChange}
                                  isSubmitted={isSubmitted}
                                  field={form.step2}
                                />
                              </Group>
                            </div>
                          )
                        case 3:
                          return (
                            <div className="pre-plan_step">
                              <div className="pre-plan_step_title">
                                Question {activeStep}/9
                                <Tooltip>
                                  Describe some of things that you like and
                                  dislike, what you are good at and what you
                                  want to achieve over the next few years.
                                  Describe what things you would like to change.
                                  What is important to you - such as family,
                                  friends or community involvement.
                                </Tooltip>
                              </div>
                              <div className="pre-plan_step_description">
                                Tell us about yourself and what you find
                                important in life.
                              </div>

                              <Group className="form_group--float-label">
                                <TextArea
                                  onChange={this.onChange}
                                  isSubmitted={isSubmitted}
                                  field={form.step3}
                                />
                              </Group>
                            </div>
                          )
                        case 4:
                          return (
                            <div className="pre-plan_step">
                              <div className="pre-plan_step_title">
                                Question {activeStep}/9
                                <Tooltip>
                                  Describe your health issues and whether you
                                  require any medication or specialised help.
                                </Tooltip>
                              </div>
                              <div className="pre-plan_step_description">
                                Do you currently have any health issues?
                              </div>

                              <Group className="form_group--float-label">
                                <TextArea
                                  onChange={this.onChange}
                                  isSubmitted={isSubmitted}
                                  field={form.step4}
                                />
                              </Group>
                            </div>
                          )
                        case 5:
                          return (
                            <div className="pre-plan_step">
                              <div className="pre-plan_step_title">
                                Question {activeStep}/9
                                <Tooltip>
                                  Do you have have any issues that affect your
                                  safety and well being? Are there any
                                  situations that could lead to a problem, tell
                                  us about them and a solution that works for
                                  you? (eg. regular falls, I need to install
                                  grab rails in my home).
                                </Tooltip>
                              </div>
                              <div className="pre-plan_step_description">
                                What personal safety concerns do you have?
                              </div>

                              <Group className="form_group--float-label">
                                <TextArea
                                  onChange={this.onChange}
                                  isSubmitted={isSubmitted}
                                  field={form.step5}
                                />
                              </Group>
                            </div>
                          )
                        case 6:
                          return (
                            <div className="pre-plan_step">
                              <div className="pre-plan_step_title">
                                Question {activeStep}/9
                                <Tooltip>
                                  How do you usually communicate? (eg. verbally,
                                  sign language, augmentative communication
                                  devices).
                                </Tooltip>
                              </div>
                              <div className="pre-plan_step_description">
                                Do you have any issues related to communication?
                              </div>

                              <Group className="form_group--float-label">
                                <TextArea
                                  onChange={this.onChange}
                                  isSubmitted={isSubmitted}
                                  field={form.step6}
                                />
                              </Group>
                            </div>
                          )
                        case 7:
                          return (
                            <div className="pre-plan_step">
                              <div className="pre-plan_step_title">
                                Question {activeStep}/9
                                <Tooltip>
                                  Is your study at secondary/tertiary level? Are
                                  you required to attend at the institution and
                                  if you do how do you get there and back. What
                                  services and equipment do you require to
                                  complete your studies? Is there anything that
                                  you need to be more successful with your
                                  study?
                                </Tooltip>
                              </div>
                              <div className="pre-plan_step_description">
                                Are you studying or do you wish to study?
                              </div>

                              <Group className="form_group--float-label">
                                <TextArea
                                  onChange={this.onChange}
                                  isSubmitted={isSubmitted}
                                  field={form.step7}
                                />
                              </Group>
                            </div>
                          )
                        case 8:
                          return (
                            <div className="pre-plan_step">
                              <div className="pre-plan_step_title">
                                Question {activeStep}/9
                                <Tooltip>
                                  Do you require services to fulfill your job
                                  such as specialised transport or assistance to
                                  and from work. Is assistive technology such as
                                  voice recognition programs an important part
                                  of your job? Is there anything that you need
                                  to maintain your job?
                                </Tooltip>
                              </div>
                              <div className="pre-plan_step_description">
                                Are you currently employed or would you like to
                                be employed?
                              </div>

                              <Group className="form_group--float-label">
                                <TextArea
                                  onChange={this.onChange}
                                  isSubmitted={isSubmitted}
                                  field={form.step8}
                                />
                              </Group>
                            </div>
                          )
                        case 9:
                          return (
                            <div className="pre-plan_step">
                              <div className="pre-plan_step_title">
                                Question {activeStep}/9
                              </div>
                              <div className="pre-plan_step_description">
                                Is there any other information that you would
                                like to share about anything that you believe is
                                important in developing your pre-plan?
                              </div>

                              <Group className="form_group--float-label">
                                <TextArea
                                  onChange={this.onChange}
                                  isSubmitted={isSubmitted}
                                  field={form.step9}
                                />
                              </Group>
                            </div>
                          )
                        default:
                          return "Unknown stepIndex"
                      }
                    })()}
                  </CSSTransition>
                </SwitchTransition>
                <Group className="form_btn-group form_group--padding-top-lg">
                  <Button
                    button={{ type: "button" }}
                    onClick={this.handleNext}
                    className="btn--secondary-light btn--width-md btn--height-sm btn--font-size-md"
                  >
                    Next
                  </Button>
                  <Button
                    button={{ type: "button" }}
                    onClick={this.requestSupportToggle}
                    className={`
                      btn--cancel-light 
                      btn--request-support 
                      btn--width-md 
                      btn--height-sm 
                      btn--font-size-md 
                      ${
                        !requestSupportIsHidden
                          ? "btn--request-support-active"
                          : ""
                      }
                      `}
                  >
                    Request Support
                  </Button>
                </Group>
              </Form>

              {plan.answers.supportTeam && (
                <RequestSupport
                  guardians={plan.answers.supportTeam}
                  planSection="AM"
                  planSubsection={activeStep}
                  isHidden={requestSupportIsHidden}
                  onToggle={this.requestSupportToggle}
                />
              )}
            </div>
          </div>
        )}
      </>
    )
  }
}

AboutMe.propTypes = {
  id: propTypes.oneOfType([propTypes.number, propTypes.string]),
  onBack: propTypes.func.isRequired,
  onNext: propTypes.func.isRequired,
  scrollToNav: propTypes.func.isRequired,
  onSaveAboutMe: propTypes.func.isRequired,
  store: propTypes.shape({
    user: propTypes.shape({
      name: propTypes.string,
      token: propTypes.string,
      list_role: propTypes.arrayOf(propTypes.number)
    }),
    plan: propTypes.shape({
      loading: propTypes.bool,
      id: propTypes.oneOfType([propTypes.string, propTypes.number]),
      answers: propTypes.shape({
        aboutMe: propTypes.shape({
          fund_management: propTypes.oneOfType([
            propTypes.string,
            propTypes.number
          ]),
          support_me: propTypes.string,
          daily_life: propTypes.string,
          about_me: propTypes.string,
          health_and_wellbeing: propTypes.string,
          safety_concerns: propTypes.string,
          communication_and_decision_making: propTypes.string,
          studying: propTypes.string,
          transportation: propTypes.string,
          extra_info: propTypes.string
        }),
        supportTeam: propTypes.arrayOf(propTypes.shape({}))
      })
    })
  }).isRequired
}

AboutMe.defaultProps = {
  id: null
}

const mapStateToProps = ({ AuthenticationReducer, PlansReducer }) => ({
  store: {
    user: AuthenticationReducer.user,
    plan: PlansReducer
  }
})

const mapDispatchToProps = dispatch => ({
  onSaveAboutMe: (token, planId, aboutMe) =>
    dispatch(saveAboutMe(token, planId, aboutMe))
})

export default connect(mapStateToProps, mapDispatchToProps)(AboutMe)
